import { useCallback, useState } from "react";

const useFormWithValidation = ({initial}) => {
  const [values, setValues] = useState(initial); //{organization:"agent"}
  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false);
  

  const handleChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;    
    setValues({ ...values, [name]: value });
    setErrors({ ...errors, [name]: target.validationMessage });
    setIsValid(target.closest("form").checkValidity());

    console.log(target.closest("form"))
  };

  const resetForm = useCallback(
    (newValues = {}, newErrors = {}, newIsValid = false) => {
      setValues(newValues);
      setErrors(newErrors);
      setIsValid(newIsValid);      
    },
    [setValues, setErrors, setIsValid]
  );

  return {
    values,
    handleChange,
    errors,
    isValid,
    resetForm,        
  };
};

export default useFormWithValidation;
